var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"contenteditable":"true"},on:{"focus":_vm.selectText,"input":function($event){return _vm.changeVal($event.target)},"blur":function($event){return _vm.checkFocus($event.target)}}},[_vm._v(_vm._s(_vm.currentVal))])}
var staticRenderFns = []

export { render, staticRenderFns }